import { useState, useEffect, useCallback } from "react";

import { toast } from "react-toastify";
import { http } from "../axios/axios";

const useEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // --- FETCH ALL ---
  const fetchEvents = useCallback(async () => {
    setLoading(true);
    try {
      const response = await http.get("/events");
      // Adjust based on your API response structure
      setEvents(response.data.data || response.data);
      setError(null);
    } catch (err) {
      setError("Failed to sync mission registry.");
      toast.error("Network Error: Could not reach event vault.");
    } finally {
      setLoading(false);
    }
  }, []);

  // --- CREATE ---
  const createEvent = async (formData) => {
    setLoading(true);
    try {
      await http.post("/events", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("Mission Deployed Successfully");
      await fetchEvents();
      return true;
    } catch (err) {
      toast.error("Deployment Failed: Check network status.");
      return false;
    } finally {
      setLoading(false);
    }
  };

  // --- UPDATE ---
  const updateEvent = async (id, formData) => {
    setLoading(true);
    try {
      await http.put(`/events/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("Mission Parameters Updated");
      await fetchEvents();
      return true;
    } catch (err) {
      toast.error("Update Blocked: Authorization Error.");
      return false;
    } finally {
      setLoading(false);
    }
  };

  // --- DELETE ---
  const deleteEvent = async (id) => {
    try {
      await http.delete(`/events/${id}`);
      setEvents((prev) => prev.filter((ev) => ev._id !== id));
      toast.warning("Mission Record Erased");
      return true;
    } catch (err) {
      toast.error("Erasure Failed: Record is protected.");
      return false;
    }
  };

  useEffect(() => {
    fetchEvents();
  }, [fetchEvents]);

  return { events, loading, error, createEvent, updateEvent, deleteEvent, refetch: fetchEvents };
};

export default useEvents;